import { Routes } from "@angular/router";
import { ClerkAuthGuardService } from "ngx-clerk-iliad";
import { OrganizationsSelectPage } from "./features/organizations/pages/select/select.page";
import { SignInRoutes } from "./features/sign-in/sign-in.routes";
import { AppSignOutPage } from "./features/sign-out/pages/sign-out.page";
import { connectRoleAdminAuthGuard } from "./shared/guards/connect-role-admin-auth.guard";
import { MfaRequirementGuard } from "./shared/guards/mfa-requirement-guard";
import { selectOrgGuard } from "./shared/guards/select-org.guard";
import { adminResolver } from "./shared/resolvers/admin-resolver";
import { invitationsResolver } from "./shared/resolvers/invitations-resolver";
import { organizationResolver } from "./shared/resolvers/organization-resolver";
import { userResolver } from "./shared/resolvers/user-resolver";
import { AppEmptyLayoutComponent } from "./shared/ui/apollo-template/components/app-empty.layout";
import { AppNoMenuLayoutComponent } from "./shared/ui/apollo-template/components/app-no-menu-layout";
import { AppLayoutComponent } from "./shared/ui/apollo-template/components/app.layout";

export const routes: Routes = [
  {
    path: "",
    canActivate: [ClerkAuthGuardService],
    resolve: {
      user: userResolver,
    },
    children: [
      {
        path: "",
        redirectTo: "organizations/select",
        pathMatch: "full",
      },
      {
        path: "signOut",
        component: AppSignOutPage,
      },
      {
        path: "organizations/select",
        component: AppNoMenuLayoutComponent,
        resolve: {
          invitations: invitationsResolver,
        },
        children: [{ path: "", component: OrganizationsSelectPage, title: "app.organization-selection.title" }],
      },
      {
        path: "organizations/:organizationId",
        component: AppLayoutComponent,
        // MFA is required for all organization-specific routes
        // If the user does not have MFA enabled, they will be redirected to the organization select page
        // and prompted to enable MFA
        //
        // also ensure that an organization is selected before proceeding to any child routes
        canActivate: [MfaRequirementGuard, selectOrgGuard],
        resolve: {
          organization: organizationResolver,
        },
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./features/organizations/organizations.routes").then((m) => m.OrganizationsRoutes),
          },
          // TODO consider moving process and transaction routes into organizations.routes
          {
            path: "processes",
            children: [
              {
                path: "",
                loadChildren: () => import("./features/processes/processes.routes").then((m) => m.ProcessesRoutes),
              },
            ],
          },
          {
            path: "transactions",
            loadChildren: () => import("./features/transactions/transactions.routes").then((m) => m.TransactionsRoutes),
          },
        ],
      },
      {
        path: "admin",
        component: AppLayoutComponent,
        canActivate: [connectRoleAdminAuthGuard],
        resolve: {
          admin: adminResolver,
        },
        loadChildren: () => import("./features/admin/admin.routes").then((m) => m.AdminRoutes),
      },
      {
        path: "transaction-overview",
        component: AppNoMenuLayoutComponent,
        loadChildren: () => import("./features/overview/overview.routes").then((m) => m.OverviewRoutes),
      },
    ],
  },
  {
    path: "",
    component: AppEmptyLayoutComponent,
    children: SignInRoutes,
  },
  {
    path: "error",
    component: AppEmptyLayoutComponent,
    children: [
      {
        path: "",
        loadComponent: () => import("./routes/generic-error/generic-error.page").then((m) => m.GenericErrorPage),
        title: "app.error.generic.title",
      },
    ],
  },
  // Error handler in case of page not found
  {
    path: "**",
    component: AppEmptyLayoutComponent,
    children: [
      {
        path: "",
        loadComponent: () => import("./routes/404/404.page").then((m) => m.Error404Page),
        title: "app.error.notFound.title",
      },
    ],
  },
];
